import moment from "moment";
import { MANUFACTURER_TAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "Manufacturer Id",
    field: "manufacturerId",
    width: 200,
  },
  {
    headerName: "Manufacturer Name",
    field: "manufacturerName",
    width: 200,
  },
  {
    headerName: "Manufacturer Group",
    field: "manufacturerGroupName",
    width: 200,
  },
  {
    headerName: "Short Code",
    field: "manufacturerShortCode",
    width: 200,
  },
  {
    headerName: "Company",
    field: "company",
    width: 200,
  },
  {
    headerName: "Updated Date",
    field: "updatedTime",
    hide: false,
    width: 200,
  },
];

export const columnDefsFunctions = {
  updatedTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
};

export const transformPayload = (manufacturer) => {
  return {
    manufacturerId: manufacturer?.manufacturerId || null,
    manufacturerName: manufacturer?.manufacturerName,
    manufacturerGroupId: manufacturer?.manufacturerGroupId?.manufacturerGroupId,
    manufacturerShortCode: manufacturer?.manufacturerShortCode,
  };
};

export const initial_state_manufacturer = {
  type: MANUFACTURER_TAB,
  label: "Manufacturer Master",
  allowMultipleTabs: false,
};
